import { useClient, useProperties } from '@/api/hooks';
import { appNavItems, filterNavByModules } from '@/components/layout/navItems';
import { usePropertyScope } from '@/contexts/PropertyContext';
import { cn } from '@/lib/cn';
import { useT } from '@/lib/i18n';
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';

export function MobileNav() {
  const { data: client } = useClient();
  const { propertyId } = usePropertyScope();
  const { data: properties } = useProperties();
  const t = useT();
  const activities = useMemo(
    () => properties?.properties.find((p) => p.id === propertyId)?.activities ?? [],
    [properties, propertyId],
  );
  const items = filterNavByModules(appNavItems, client?.modules, activities);

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-manejai-moss/40 bg-manejai-forest shadow-[0_-4px_24px_rgba(27,67,50,0.35)] safe-area-pb">
      <div className="overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div className="mx-auto flex w-max min-w-full items-stretch justify-center gap-0.5 px-2 py-1.5">
        {items.map(({ to, icon: Icon, labelKey, mobileLabelKey, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'relative flex min-w-[4.25rem] shrink-0 flex-col items-center gap-0.5 rounded-xl px-2 py-2 text-[10px] font-medium transition-colors',
                isActive ? 'text-white bg-white/15' : 'text-white/65 hover:text-white/90',
              )
            }
          >
            <Icon className="h-5 w-5 shrink-0" strokeWidth={2} />
            <span className="max-w-[4.5rem] truncate text-center leading-tight">
              {t(mobileLabelKey ?? labelKey)}
            </span>
          </NavLink>
        ))}
        </div>
      </div>
    </nav>
  );
}
